import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-coe-reject',
  templateUrl: './coe-reject.component.html',
  styleUrls: ['./coe-reject.component.css'],
})
export class CoeRejectComponent implements OnInit {
  // FormGroup for rejection reason
  // Contains fields for id, status, and reason
  reasonForm: FormGroup;
  datas;
  private getApi = environment.url + 'coe/dashboard?id=';
  private coeapproval = environment.url + environment.coeapproval;
  private HistoryApi = environment.url + 'coe/history?id=';
  // API endpoint to save rejection reason
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialogRef: MatDialogRef<CoeRejectComponent>
  ) {
    this.reasonForm = this.fb.group({
      id: [''],
      status: [''],
      reason: ['', [Validators.required]],
    });
    this.datas = data;
  }
  ngOnInit(): void {}
  get add() {
    return this.reasonForm.controls;
  }
  historyData;
  noData = false;
  // Fetch the history of the application
  // If no history data is found, set noData to true
  HistoryModal() {
    let id = sessionStorage.getItem('applicationId');
    return this.makeapi
      .method(this.HistoryApi + id, '', 'get')
      .subscribe((data) => {
        if (data.coeAppHistory) {
          this.noData = false;
          this.historyData = data.coeAppHistory;
        } else {
          this.noData = true;
        }
      });
  }
  // User ID and Application ID from session storage
  // Used to identify the user and application for the rejection reason
  userID = sessionStorage.getItem('userId');
  ApplicationId = sessionStorage.getItem('applicationId');
  saveReason() {
    if (this.reasonForm.invalid) {
      this.reasonForm.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      let req = {
        id: this.ApplicationId,
        userId: this.userID,
        status: this.datas._id,
        remarks: this.reasonForm.value.reason,
      };
      this.getdata.amizhthLoader('show');
      return this.makeapi
        .method(this.coeapproval, req, 'post')
        .subscribe((data) => {
          this.getdata.amizhthLoader('hide');
          if (data.responseStatus !== 'Failed') {
            this.cancelReason();
            this.notify.notifysuccess(data.responseMessage);
            window.location.reload();
          } else {
            this.notify.notifyError(data.responseMessage);
          }
        });
    }
  }
  // Save the rejection reason to the API
  cancelReason() {
    this.reasonForm.reset();
    this.dialogRef.close();
  }
  // Cancel the rejection reason and close the dialog
  // Fetch the dashboard data for the user
  dashboardData: any = {};
  getValue() {
    this.dashboardData = {};
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('userId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');
        this.dashboardData = data;
      });
  }
}
